// Handle add to cart buttons on product cards using event delegation
(function() {
  // Use event delegation on document level to handle all add-to-cart buttons
  document.addEventListener('click', async function(e) {
    const button = e.target.closest('[data-add-to-cart]');

    if (!button) return;

    e.preventDefault();
    e.stopPropagation();

    const variantId = button.getAttribute('data-product-id');

    // Disable button during request
    button.disabled = true;

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      });

      if (response.ok) {
        // Trigger cart update event - the cart drawer listens for this
        document.dispatchEvent(new CustomEvent('cart:update'));

        // Open the cart drawer
        const cartDrawer = document.getElementById('cart-drawer');
        if (cartDrawer) {
          cartDrawer.classList.add('is-open');
          document.body.style.overflow = 'hidden';
        }
      } else {
        const error = await response.json();
        console.error('Error adding to cart:', error);
        alert(error.description || 'Error adding product to cart');
      }
    } catch (error) {
      console.error('Error adding to cart:', error);
      alert('Error adding product to cart');
    } finally {
      // Re-enable button
      button.disabled = false;
    }
  });
})();
